import { createAction, props } from '@ngrx/store';
import { BookingSearchState } from './booking-search.state';

/** StateDetailsActions */
const ACTION_SET = '[BookingSearch] set';
const ACTION_UPDATE = '[BookingSearch] update';
const ACTION_RESET = '[BookingSearch] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setBookingSearch = createAction(ACTION_SET, props<BookingSearchState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateBookingSearch = createAction(ACTION_UPDATE, props<Partial<BookingSearchState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetBookingSearch = createAction(ACTION_RESET);
